export const COUPON_CARD_VARIANT = {
    DEFAULT: 'default',
    DETAIL: 'detail',
} as const;

export type CouponCardVariant = (typeof COUPON_CARD_VARIANT)[keyof typeof COUPON_CARD_VARIANT];
export const DEFAULT_COUPON_IMAGE = 'https://static-development.kidsplaza.vn/assets/icons/voucher.png';
